import SidebarMenuMain from "./SidebarMenuMain";

const SidebarMenu = () => {
    return (
        <div className='app-sidebar-menu overflow-hidden flex-column-fluid'>
            <div
                id='sai_app_sidebar_menu_wrapper'
                className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
                data-sai-scroll='true'
                data-sai-scroll-activate='true'
                data-sai-scroll-height='auto'
                data-sai-scroll-dependencies='#sai_app_sidebar_logo, #sai_app_sidebar_footer'
                data-sai-scroll-wrappers='#sai_app_sidebar_menu'
                data-sai-scroll-offset='5px'
                data-sai-scroll-save-state='true'
            >
                <div
                className='menu menu-column menu-rounded menu-sub-indention px-3'
                id='#sai_app_sidebar_menu'
                data-sai-menu='true'
                data-sai-menu-expand='false'
                >
                    <SidebarMenuMain />
                </div>
            </div>
        </div>
    )
}

export default SidebarMenu;